import { apiClient } from './api'

export interface LessonLearned {
  id: number
  organization_id: number | null
  project_id: number | null
  program_id: number | null
  author_id: number | null
  author?: { id: number; full_name: string | null; email: string }
  title: string
  description: string
  category: string | null
  type: 'success' | 'challenge' | 'improvement' | 'innovation' | null
  phase: string | null
  impact: number | null
  status: 'implemented' | 'shared' | 'action-pending' | 'archived'
  action_taken: string | null
  benefits_realized: string | null
  tags: string[] | null
  created_at: string
  updated_at: string
}

export interface LessonLearnedCreate {
  title: string
  description: string
  category?: string
  type?: string
  phase?: string
  impact?: number
  status?: string
  action_taken?: string
  benefits_realized?: string
  tags?: string[]
  project_id?: number
  program_id?: number
}

export interface LessonLearnedUpdate {
  title?: string
  description?: string
  category?: string
  type?: string
  phase?: string
  impact?: number
  status?: string
  action_taken?: string
  benefits_realized?: string
  tags?: string[]
  project_id?: number
  program_id?: number
}

export const lessonsLearnedService = {
  async list(params?: {
    category?: string
    type?: string
    project_id?: number
    program_id?: number
    skip?: number
    limit?: number
  }): Promise<LessonLearned[]> {
    const response = await apiClient.get<LessonLearned[]>('/api/v1/lessons-learned', { params })
    return response.data
  },

  async get(id: number): Promise<LessonLearned> {
    const response = await apiClient.get<LessonLearned>(`/api/v1/lessons-learned/${id}`)
    return response.data
  },

  async create(data: LessonLearnedCreate): Promise<LessonLearned> {
    const response = await apiClient.post<LessonLearned>('/api/v1/lessons-learned', data)
    return response.data
  },

  async update(id: number, data: LessonLearnedUpdate): Promise<LessonLearned> {
    const response = await apiClient.put<LessonLearned>(`/api/v1/lessons-learned/${id}`, data)
    return response.data
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/v1/lessons-learned/${id}`)
  },
}
